import { Injectable } from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http"
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class RequestService {
  
  // private url = "http://192.168.1.53:5001";
  // private url = "http://51.68.190.11:5001";
  // private url = "http://localhost:5000";
  private url = "https://andron.fdcmessina.org/andron";

  public token : string;

  constructor(private http: HttpClient) {}


  createAuthHeader(){
    let headers= new HttpHeaders({
        'Authorization': 'Bearer ' + this.token,
    })
    return headers
  }
  
  createHeader(){
    let headers= new HttpHeaders({
    })
    return headers
  }

  post({ path, data, httpHeaders=this.createAuthHeader() ,handler, error=(error)=>{} }){
    this.http.post(this.url+path, data, {headers: httpHeaders}).subscribe(
      {
        next: handler,
        error: error,
      }
    )
  }

  put({path, data={}, httpHeaders=this.createAuthHeader(), httpParam={} ,handler, error=(error)=>{}}){
    this.http.put(this.url+path,data,{ headers: httpHeaders, params:new HttpParams({fromObject: httpParam})}).subscribe(
      {
        next: handler,
        error: error,
      }
    )
  }  


  delete({path, httpHeaders=this.createAuthHeader(), httpParam={} , handler, error=(error)=>{}}){

    this.http.delete(this.url+path,{ headers: httpHeaders, params:new HttpParams({fromObject: httpParam})}).subscribe(
      {
        next: handler,
        error: error,
      }
    )
  }

  get({ path, handler, error=(error)=>{}, httpHeaders=this.createAuthHeader(), httpParam={} }){
    this.http.get(this.url+path,{ headers: httpHeaders, params:new HttpParams({fromObject: httpParam})}).subscribe(
      {
        next: handler,
        error: error,
      }
    )
  }

  // Metodo per ottenere tutte le nazioni
  getCountries(): Observable<any[]> {
    // return this.http.get<any[]>("https://restcountries.com/v3.1/all");
    return this.http.get<any[]>("https://countriesnow.space/api/v0.1/countries/iso");

    
  }

   // Ottieni le regioni di un paese specifico
   getRegionsByCountry(country: string): Observable<any> {
    return this.http.post<any>('https://countriesnow.space/api/v0.1/countries/states', { "country": country });
  }

  // Ottieni le regioni di un paese specifico
  getCitiesByCountryByState(regione: string, stato:string): Observable<any> {
    return this.http.post<any>("https://countriesnow.space/api/v0.1/countries/state/cities", {
      "country": regione,
      "state": stato
    });
  }

}
